/**
 *
 * AddEditGroup
 *
 */

import React, { memo, FunctionComponent, useState } from 'react';
import { useIntl } from 'react-intl';
import messages from './messages';
import {
  ComponentDialogBody,
  StyledDialogActionsBar,
  StyledModalAction,
} from '../../../../components/DiaogWrap/styles';
import { Column, Row, Wrap } from '../../../../assets/styledAssets/grid';
import {
  StyledFormField,
  StyledLabel,
} from '../../../../components/FormField/styles';
import { Input } from '@progress/kendo-react-inputs';
import { Group } from '../../groups';

interface IProps {
  onCancel: () => void;
  onSave: (g: Partial<Group>) => void;
  group?: Group;
}

const AddEditGroup: FunctionComponent<IProps> = ({
  group,
  onCancel,
  onSave,
}) => {
  const intl = useIntl();
  const [groupState, setGroupState] = useState<Partial<Group>>(group || {});

  return (
    <>
      <ComponentDialogBody>
        <Row>
          <Wrap margin={'0 0 3rem'} width={'100%'}>
            <Column xs={100} md={100}>
              <StyledLabel>{intl.formatMessage(messages.name)}</StyledLabel>
              <StyledFormField>
                <Input
                  onChange={(e) =>
                    setGroupState({
                      ...groupState,
                      name: e.target.value as string,
                    })
                  }
                  value={groupState?.name}
                />
              </StyledFormField>
            </Column>
            <Wrap width={'100%'} margin={'2rem 0 0 0'}>
              <Column xs={100} md={100}>
                <StyledLabel>
                  {intl.formatMessage(messages.description)}
                </StyledLabel>
                <StyledFormField>
                  <Input
                    onChange={(e) =>
                      setGroupState({
                        ...groupState,
                        description: e.target.value as string,
                      })
                    }
                    value={groupState?.description || ''}
                  />
                </StyledFormField>
              </Column>
            </Wrap>
          </Wrap>
        </Row>
      </ComponentDialogBody>
      <StyledDialogActionsBar>
        <StyledModalAction onClick={onCancel}>
          {intl.formatMessage(messages.cancel)}
        </StyledModalAction>
        <StyledModalAction accent onClick={() => onSave(groupState)}>
          {intl.formatMessage(messages.save)}
        </StyledModalAction>
      </StyledDialogActionsBar>
    </>
  );
};

export default memo(AddEditGroup);
